import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid, } from 'uuid';
import moment from 'moment';
import ConversationModal from './ConversationModal';
import './ConversationViewer.css';

class Conversation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: undefined,
      convoIndex: undefined,
    };
  }

  selectConvo(conversation, index) {
    this.setState({ selected: conversation, convoIndex: index, });
  }

  buildConvoBlock(task, input) {
    return <ConversationModal task={task} input={input} />;
  }

  getDurationOfConversation(startTime, endTime) {
    const rawDuration = moment.duration(moment(endTime).diff(moment(startTime)));

    if (rawDuration.asHours >= 23) {
      const durationOfConvoWithDays = `${rawDuration.days()}d ${rawDuration.hours()}h ${rawDuration.minutes()}m ${rawDuration.seconds()}s`;
      return durationOfConvoWithDays;
    }
    if (rawDuration.asHours() < 1) {
      const durationOfConvoWithoutHours = `${rawDuration.minutes()}m ${rawDuration.seconds()}s`;
      if (rawDuration.asMinutes() < 1) {
        const durationOfConvoOnlySeconds = `${rawDuration.seconds()}s`;
        return durationOfConvoOnlySeconds;
      }
      return durationOfConvoWithoutHours;
    }
    return `${rawDuration.hours()}h ${rawDuration.minutes()}m ${rawDuration.seconds()}s`;
  }

  findConversationEndEpochTimestamp(conversation) {
    const firstState = conversation.state[0];
    if (firstState.taskId === '_start') {
      const endValue = conversation.state[conversation.state.length - 1].timeEntered;
      return endValue;
    }
    return firstState.timeEntered;
  }

  render() {
    const {
      selected, convoIndex,
    } = this.state;
    if (selected !== undefined && selected.state.length > 1 && selected.state[1].timeEntered < selected.state[0].timeEntered) {
      selected.state = selected.state.reverse();
    }
    const { conversations, } = this.props;
    const inputs = conversations.map(conversation => conversation.state.map((task) => {
      const { input, } = task.input;
      return input;
    }));

    return (
      <div className="convo-wrapper">
        <div className="convo-tab">
          <div className="flex-column nav-pills">
            {conversations.map((conversation, index) => {
              const conversationStartEpochTimestamp = conversation.creationDate;
              const conversationEndEpochTimestamp = this.findConversationEndEpochTimestamp(conversation);
              const consversationStateLength = conversation.state.length;
              const yearDayweekTimeFormat = 'MMM Do, YYYY / dddd';
              const convoStartTimeFormat = 'hh:mm:ss A';
              const convoEndTimeFormat = 'hh:mm:ss A (z)';
              const conversationNumber = index + 1;

              return (
                <button
                  type="button"
                  className="pill-button"
                  key={uuid()}
                  onClick={() => {
                    this.selectConvo(conversation, index);
                  }}
                >
                  {`${moment(conversationStartEpochTimestamp)
                    .tz('America/Chicago')
                    .format(`${conversationNumber} -  ${yearDayweekTimeFormat}[\n]${convoStartTimeFormat}`)} - ${moment(conversationEndEpochTimestamp).tz('America/Chicago').format(convoEndTimeFormat)}
                  Duration: ${this.getDurationOfConversation(conversationStartEpochTimestamp, conversationEndEpochTimestamp)}
                  ${consversationStateLength} states`}
                </button>
              );
            })}
          </div>
        </div>
        <div className="flow-wrapper">
          <div className="convo-flow">
            {selected === undefined
              ? null
              : (
                <div className="conversation-overview">
                  <div className="conversation-details">
                    <h5>Selected Conversation Details</h5>
                    <span>Conversation Number: {convoIndex + 1}</span>
                    <br />
                    <span>Duration:
                      {this.getDurationOfConversation(selected.creationDate, this.findConversationEndEpochTimestamp(selected))}
                    </span>
                    <br />
                    <span>First Step: {selected.state[0].taskId}</span>
                    <br />
                    <span>Last Step: {selected.state[selected.state.length - 1].taskId}</span>
                    <br />
                    <span>Number of States: {selected.state.length}</span>
                  </div>
                </div>
              )}
            {selected === undefined
              ? null
              : selected.state.map((task, index) => {
                return (
                  <React.Fragment key={uuid()}>
                    <div className="convo-row">
                      <h5 className="timestamp-header">
                        Time Entered:
                        {moment(task.timeEntered)
                          .tz('America/Chicago')
                          .format('MMM Do, YYYY, hh:mm:ss A z')}
                      </h5>
                      {this.buildConvoBlock(task, inputs[convoIndex][index])}
                    </div>
                    <div className="flow-line-row">
                      {index === selected.state.length - 1 ? null : <div className="flow-line" />}
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

Conversation.propTypes = {
  conversations: PropTypes.instanceOf(Array).isRequired,
};

export default Conversation;
